import React from "react";

export function useNetwork(): { isOnline: boolean } {
  const [isOnline, setIsOnline] = React.useState<boolean>(true);

  React.useEffect(() => {
    const onlineStatus =
      typeof navigator !== "undefined" ? navigator.onLine : true;
    setIsOnline(onlineStatus);

    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return { isOnline };
}
